import React, { useEffect, useState } from "react";
import { Check, Copy, Link } from "lucide-react";
import { copyText } from "./teacherMocksHelpers";

export default function PublishedMockModal({ publication, onClose }) {
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    if (!publication) setCopied(false);
  }, [publication]);

  useEffect(() => {
    if (!copied) return undefined;

    const timeout = setTimeout(() => setCopied(false), 2000);
    return () => clearTimeout(timeout);
  }, [copied]);

  if (!publication) return null;

  const handleCopy = () => {
    copyText(publication.publicUrl);
    setCopied(true);
  };

  return (
    <div className="teacher-mocks-published-overlay" role="dialog" aria-modal="true" aria-label="Simulado publicado">
      <div className="teacher-mocks-published-modal">
        <div className="teacher-mocks-published-content">
          <div className="teacher-mocks-published-icon">
            <Check size={28} strokeWidth={3} aria-hidden="true" />
          </div>
          <p className="teacher-mocks-published-title">Simulado publicado!</p>
          <p className="teacher-mocks-published-message">
            &quot;{publication.name}&quot; foi publicado e já está visível para {publication.studentsCount} alunos.
          </p>

          <div className="teacher-mocks-published-stats">
            <div>
              <span>Questões</span>
              <strong>{publication.questionsCount}</strong>
            </div>
            <div>
              <span>Alunos</span>
              <strong>{publication.studentsCount}</strong>
            </div>
          </div>

          <div className="teacher-mocks-published-link">
            <Link size={14} aria-hidden="true" />
            <span>{publication.publicUrl}</span>
            <button type="button" onClick={handleCopy}>
              <Copy size={12} aria-hidden="true" />
              {copied ? "Copiado!" : "Copiar link"}
            </button>
          </div>

          <button type="button" className="teacher-mocks-published-close" onClick={onClose}>
            Voltar aos simulados
          </button>
        </div>
      </div>
    </div>
  );
}
